import {trigger} from "../../../utils/events/trigger";
import {Lightbox} from "../../classes/Lightbox";

export const initHash = () => {
	window.addEventListener(`hashchange`, ( evt ) => {
		const hash = location.hash.split( `/` );
		
		if ( hash[0] === `#lightbox` )
		{
			if ( hash[1] === `application-form` || hash[1] === `3d-tour` || hash[1] === `room-tour` )
			{
				let data;

				if ( hash[1] === `application-form` )
				{
					data = {
						"action": "get-ajax-form", 
						"form-name": "application_form"
					};
				}
				else if ( hash[1] === `3d-tour` )
				{
					data = {
						"action": "get-ajax-form", 
						"form-name": "3d_tour",
						"complex": `${hash[2]}`
					};
				}
				else if ( hash[1] === `room-tour` )
				{
					data = {
						"action": "get-ajax-form", 
						"form-name": "3d_tour",
						"room": true,
						"complex": `${hash[2]}`
					};
				}

				const formData = new FormData();
				
				for ( let key in data ) 
				{
					if (data.hasOwnProperty(key))
					{
						formData.append( key, data[key]);
					}
				}

				window.fetch(`/ajax/`, {
					method: `POST`,
					credentials: `same-origin`,
					headers: {
						"X-Requested-With": `XMLHttpRequest`,
					},
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						Lightbox.open(data.rendered);
					})
					.catch((err) => {
						
					});
			}
		}
	});

	/*trigger(window, `hashchange`);*/
};
